import React from "react";

const CurrencyInput = ({
  showPrefix = false,
  placeholder,
  children,
  onChange,
  value,
}) => {
  const formatWithThousandSeparator = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const handleInputChange = (event) => {
    const rawValue = event.target.value;
    const cleanedValue = rawValue.replace(/\D/g, ""); // Remove todos os caracteres não numéricos
    let formattedValue = "";

    if (cleanedValue.length <= 2) {
      formattedValue = `0,${cleanedValue.padStart(2, "0")}`;
    } else {
      const integerPart = parseInt(cleanedValue.slice(0, -2)); // Converter para inteiro
      const decimalPart = cleanedValue.slice(-2);
      formattedValue = `${formatWithThousandSeparator(
        integerPart
      )},${decimalPart}`;
    }

    onChange(formattedValue);
  };

  const inputProps = {
    value: value && showPrefix ? `R$ ${value}` : value,
    onChange: handleInputChange,
    placeholder: placeholder ? placeholder : "0,00",
  };

  return (
    <div>
      {children ? children(inputProps) : <input type="text" {...inputProps} />}
    </div>
  );
};

export default CurrencyInput;
